import { createContext, useContext } from 'react';
/**
 * @type {import('react').Context<{ id: string | null, horizontal: boolean }>}
 */

export var FormGroupContext = /*#__PURE__*/createContext({
  id: null,
  horizontal: true
});
export var useFormGroupContext = function () {
  return useContext(FormGroupContext);
};
/**
 * @param {string} id
 * @return {string | null}
 */

export var useFormGroupContextId = function (id) {
  var contextId = useFormGroupContext().id;
  return id || contextId;
};